export const getWGCornmealPackage = newProduct => {
  let newWGCornmealPackage = {
    UPC: newProduct.UPC,
    Texture: newProduct.Texture,
    Color: newProduct.Color,
    Size: newProduct.Size,
    WholeGrainCert: newProduct.WholeGrainCert,
  }

  return newWGCornmealPackage
}

export const updateWGCornmealPackage = newProduct => {
  let newWGCornmealPackage = {
    UPC: newProduct.UPC,
    Texture: newProduct.Texture,
    Color: newProduct.Color,
    Size: newProduct.Size,
    WholeGrainCert: newProduct.WholeGrainCert,
  }

  return newWGCornmealPackage
}
